import React, { Suspense } from 'react';
import { translate } from 'base/shared/Localization';
import { GRAPH_TYPES, TARGET_VALUES } from '../../constants';

const MetricEvolutionGraph = React.lazy(() => import('./metric-evolution-graph'));

const ViewEvolutionGraph = ({ evolution }) => (
  <Suspense fallback={<div />}>
    <MetricEvolutionGraph
      dataQa="view-metric-evolution-graph"
      metricEvolution={evolution}
      subTitle={translate('lister.analytics_subtitle_view_evolution_text')}
      targetValue={TARGET_VALUES[GRAPH_TYPES.VIEW_EVOLUTION]}
      title={translate('lister.analytics_subtitle_view_evolution')}
      xLabel={translate('lister.analytics_evo_item_date')}
      yLabel={translate('lister.analytics_evo_item_views')}
    />
  </Suspense>
);

export default ViewEvolutionGraph;
